<template>
  <div ref="view" class="goods-vip-forever">
    <div class="bg"><img class="bg-img" src="https://img-cdn1.ylyk.com/image/1623752349415_m1623747562000_s612248.jpg" alt=""></div>
    <!-- 无限卡 -->
    <div ref="card" class="card">
      <!-- <div><img class="goods-vip-forever" src="../../../images/goods-vip-forever/goods-vip-forever_my.png" alt=""></div> -->
      <!-- 无限卡内容 -->
      <div>
        <!-- 卡片背景上 -->
        <!-- <img class="card-img" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603542106735_s110260.jpg" alt=""> -->
        <img class="card-img" src="https://img-cdn1.ylyk.com/image/1623752349415_m1623747561000_s20004.jpg" alt="">
        <!-- 卡片数据 -->
        <div class="card-img card-data">
          <div class="card-data_inner">
            <div class="card-price">
              <span class="price-unit">￥</span>
              <span class="price-value">{{ salePrice }}</span>
              <img class="icon-price-discounts" v-if="discountTotal > 0"
                src="../../../images/goods-vip-forever/icon-price-discounts-makeup.png" alt="">
              <img class="icon-price-discounts" v-else
                src="../../../images/goods-vip-forever/icon-price-discounts.png" alt="">
            </div>
            <div class="card-desc">
              友邻节专享价
            </div>
          </div>
        </div>
        <!-- 卡片背景中下 -->
        <!-- <img class="card-img img-data" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603542106729_s102066.jpg" alt=""> -->
        <img class="card-img img-data" src="https://img-cdn1.ylyk.com/image/1623752349415_m1623747561000_s4337.jpg" alt="">
        <!-- 查看抵扣课程列表 -->
        <div class="card-equity-info">
          <div class="card-discount-data flex" v-if="discountTotal > 0">
            <span>*已抵扣历史消费金额共{{ discountTotal }}元</span>
            <span @click="detailView('goods-order-list')">
              <span>购课记录</span>
              <img class="icon-24" src="../../../images/goods-vip-forever/icon-direction-card-link.png" alt="">
            </span>
          </div>
          <div class="card-discount-not" v-else>
            <img class="icon-32" src="../../../images/goods-vip-forever/icon-protocol.png" alt="">
            <span>享有无限畅听权益</span>
          </div>
        </div>
      </div>
      <!-- 无限卡协议 -->
      <!-- <div class="card-protocol" v-if="false"> -->
      <div class="card-protocol" v-if="true">
        <span class="card-icon">
          <img class="icon-32" v-if="form.protocol === 1" @click="toggleValue('protocol')" src="../../../images/goods-vip-forever/icon-checkbox-select.png" alt="">
          <img class="icon-32" v-if="form.protocol === 0" @click="toggleValue('protocol')" src="../../../images/goods-vip-forever/icon-checkbox.png" alt="">
          <span class="link" @click="detailView('goods-vip-forever-protocol2022')">同意《无限卡购买协议》</span>
        </span>
        <span class="card-icon right" @click="detailView('goods-vip-forever-protocol2022')">
          <span class="text-left">查看</span>
          <img class="icon-24" src="../../../images/goods-vip-forever/icon-direction-right_arrow.png" alt="">
        </span>
      </div>
    </div>
    <!-- 无限卡权益 -->
    <div class="vip-forever">
      <!-- <div><img class="goods-vip-forever" src="../../../images/goods-vip-forever/goods-vip-forever.png" alt=""></div> -->
      <!-- <div>
        <img class="course-list absolute" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603280237460_s101884.jpg" alt="">
        <img class="course-list" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603280237460_s101884.jpg" alt="">
      </div> -->
      <!-- <div><img class="goods-gift" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603546426000_s399764.jpg" alt=""></div> -->
      <!-- <div><img class="goods-new-course" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603542106757_s900879.jpg" alt=""></div> -->
      <div><img class="goods-new-course" src="https://img-cdn1.ylyk.com/image/1623739501448_m1623754046320_s1048989.jpg" alt=""></div>
      <!-- <div><img class="goods-new-course" src="https://img-cdn1.ylyk.com/image/1603678387992_m1603542106776_s800071.jpg" alt=""></div> -->
      <div><img class="goods-new-course1" src="https://img-cdn1.ylyk.com/image/1623739501448_m1623757576835_s2240004.jpg" alt=""></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'mint-ui';
import { toFixedFloat } from '@/utils'

export default {
  name: 'goods-vip-forever',
  components: {},
  props: {
    goods: { type: Object, default: () => {} }
  },
  data() {
    return {
      form: {
        protocol: 0
      }
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'disCountOrderList'
    ]),
    discountList() {
      return this.disCountOrderList || []
      // return []
    },
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return toFixedFloat(total, 2)
    },
    salePrice() {
      let salePrice = this.goods.salePrice - this.discountTotal
      salePrice = salePrice < 0 ? 0 : toFixedFloat(salePrice, 2)
      return salePrice
    }
  },
  methods: {
    toggleValue(name) {
      const value = this.form[name]
      this.form[name] = value ? 0 : 1
    },
    // 检查是否勾选协议  老的无限卡需要 2021以后不需要了
    isChecked() {
      if (this.form.protocol === 0) {
        Toast({ message: '请阅读并勾选《无限卡购买协议》，否则无法进行购买', position: 'middle' })
        // 定位无限卡位置
        const { card } = this.$refs
        if (card) {
          [document.body, document.documentElement].map(element => { element.scrollTop = card.offsetTop })
        }
      }
      return this.form.protocol
    },
    // 查看页面
    detailView(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-vip-forever {
  background-color: #002B2C;
  position: relative;
  .bg {
    .bg-img {
      width: 100%;
      height: auto;
    }
  }
  .card {
    // margin-top: -1.5rem;
    position: absolute;
    top: 8.5rem;
    .card-img {
      width: 87.2%;
      margin: 0 6.4%;
      &.img-data {
        margin-top: -0.08rem;
      }
    }
    // 权益抵扣信息
    .card-equity-info {
      margin: -0.86rem 11% 0 11%;
      // margin: -.52rem 11% 0 11%;
      color: #6C310CFF;
      justify-self: start;
      .flex {
        display: flex;
        justify-content: space-between;
      }
      .card-discount-not {
        color: #FFF2E0FF;
      }
      span {
        font-size: .26rem;
        margin-left: .08rem;
        margin-bottom: .08rem;
      }
    }
    // 无限卡
    .card-data {
      position: absolute;
      .card-data_inner {
        margin: -2rem 0 0 0.5rem;
        // 价格
        .card-price {
          .price-unit {
            font-size: .4rem;
            color: #4A1919;
          }
          .price-value {
            font-size: .92rem;
            color: #4A1919;
          }
          .icon-price-discounts {
            width: 1.04rem;
            vertical-align: 0.35rem;
          }
        }
        // 价格详情
        .card-desc {
          font-size: .32rem;
          font-weight: 500;
          color: #6C310C;
          margin-top: .2rem;
        }
      }
    }
    // 无限卡协议
    .card-protocol {
      display: flex;
      justify-content: space-between;
      margin: .5rem 7% 0 8%;
      color: #FFFFFF;
      font-size: .26rem;
      .link {
        text-decoration: underline;
        margin-left: 0.15rem;
        color:#FDD8AC
      }
      .text-left {
        margin-right: 0.03rem;
        vertical-align: bottom;
      }
      .card-icon {
        margin-right: 0.15rem;
        // .line{
        // }
      }
    }
    .goods-vip-forever {
      width: 73.6%;
      margin: 0 13.33% .75rem 13.07%;
    }
    // 图标
    .icon-32 {
      vertical-align: sub;
      width: 0.32rem;
    }
    .icon-24 {
      vertical-align: sub;
      width: 0.24rem;
    }
  }
  .vip-forever {
    margin-top: 1rem;
    .goods-vip-forever {
      width: 45.87%;
      margin: 0 27.2% .75rem 26.93%;
    }
    .course-list {
      width: 87.2%;
      height: auto;
      margin: 0 6.4%;
      &.absolute {
        position: absolute;
      }
    }
    .goods-gift {
      width: 100%;
      height: auto;
      margin-top: -1.2rem;
    }
    .goods-new-course {
      width: 100%;
      height: auto;
      margin-top: -1.1rem;
    }
    .goods-new-course1 {
      width: 100%;
      height: auto;
      margin-top: -.3rem;
    }
  }
}
</style>
